import type { TagResponse } from "@redotech/effect-api-shared/rpc/tag";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import type { RedoPlatformRpcClient } from "@redotech/redo-merchant-platform-rpc/client";
import type { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { createAssigneesAdvancedFilter } from "./assignees-filter";
import { ChannelsAdvancedFilter } from "./channels-filter";
import { ClosedAtAdvancedFilter } from "./closed-at-filter";
import { createConversationTagsAdvancedFilter } from "./conversation-tags-filter";
import { CreatedAtAdvancedFilter } from "./created-at-filter";
import { createCustomerTagsAdvancedFilter } from "./customer-tags-filter";
import { LastCustomerMessageAtAdvancedFilter } from "./last-customer-message-at-filter";
import { LastMerchantMessageAtAdvancedFilter } from "./last-merchant-message-at-filter";
import { LastResponseAtAdvancedFilter } from "./last-response-at-filter";
import { createMentionsAdvancedFilter } from "./mentions-filter";
import { ReadStatusAdvancedFilter } from "./read-status-filter";
import { StatusAdvancedFilter } from "./status-filter";
import { WordsAdvancedFilter } from "./words-filter";

export function getConversationAdvancedFilters(options?: {
  effectApi?: EffectApiContext;
  platformRpc?: RedoPlatformRpcClient;
  tags?: TagResponse[];
}): AdvancedTableFilter[] {
  return [
    StatusAdvancedFilter,
    ChannelsAdvancedFilter,
    createAssigneesAdvancedFilter(options?.platformRpc),
    createConversationTagsAdvancedFilter(options?.tags ?? []),
    createCustomerTagsAdvancedFilter(options?.effectApi),
    createMentionsAdvancedFilter(options?.effectApi),
    ReadStatusAdvancedFilter,
    WordsAdvancedFilter,
    CreatedAtAdvancedFilter,
    ClosedAtAdvancedFilter,
    LastResponseAtAdvancedFilter,
    LastCustomerMessageAtAdvancedFilter,
    LastMerchantMessageAtAdvancedFilter,
  ];
}
